import React, { useRef, useEffect, useState, useContext } from "react";
import { useTranslation } from 'react-i18next';
import moment from "moment";
import validator from "validator";
import { sanitizeInput } from "../utils/inputSanitizer.ts";
import { AppContext } from "../AppContextProvider";
import { createStorageJson } from "../utils/feedback/feedbackJsonConvert";
import ProfileJsonStorage from "../utils/storage/profileJsonStorage";
import { AvalancheContext, useAvalancheProvider } from "../avalanche/AvalancheProvider";
import { WalletProviderContext } from "../walletprovider/WalletProvider";
import { DwMpcWalletBackendProviderContext } from "../mpcwalletprovider/DwMpcWalletBackendProvider";
import close from "../assets/media/icons/cross-thin.svg";
import * as constants from "../constants";
import { WarningTicket, InformationsTicket, NotificationsTicket } from "../components/TicketsComponent";

import {
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBBtn,
  MDBRadio,
} from "mdb-react-ui-kit";
import FeedbackJsonStorage from "../utils/feedback/feedbackJsonStorage";
import { sendFeedbackEmail } from "../utils/feedback/feedbackApi";
import { collectLog, createEmptyLogsAndVars, dwReportError, recordVariable } from "../utils/diagnostics/clientErrors";

export default function EmailModal(props) {
  const { t } = useTranslation();
  const [from_email, setFrom_email] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [message_1, setMessage_1] = useState("");
  const [message_2, setMessage_2] = useState("");
  const [message_3, setMessage_3] = useState("");
  const [question_1, setQuestion_1] = useState("");
  const [question_2, setQuestion_2] = useState("");
  const [question_3, setQuestion_3] = useState("");
  const [question_4, setQuestion_4] = useState("");
  const [question_5, setQuestion_5] = useState("");
  const [question_6, setQuestion_6] = useState("");
  const [question_7, setQuestion_7] = useState("");
  const [question_8, setQuestion_8] = useState("");
  const [question_9, setQuestion_9] = useState("");
  const [question_10, setQuestion_10] = useState("");
  const [isSendingInProgress, setIsSendingInProgress] = useState(false);
  const [isSentTo, setIsSentTo] = useState(false);
  const [isWarningTicket, setIsWarningTicket] = useState(false);
  const [isSubmitActive, setIsSubmitActive] = useState(false);
  const context = useContext(AppContext);
  const avalancheContext = useContext(AvalancheContext);
  const profileJsonStorage = ProfileJsonStorage.create(avalancheContext, walletContext);
  const feedbackJsonStorage = FeedbackJsonStorage.create(avalancheContext);
  const walletContext = useContext(WalletProviderContext);
  const { selectedAccount } = useContext(WalletProviderContext);
  const { storageProps } = useContext(DwMpcWalletBackendProviderContext);

  const getAccount = async () => {
    const logsAndVars = createEmptyLogsAndVars("EmailModal:getAccount");
    try {
      const res = await profileJsonStorage.getDataForAddress(selectedAccount);
      recordVariable(logsAndVars, "profile data for " + selectedAccount, res);
      setFrom_email(res?.email ?? "");
    } catch (error) {
      dwReportError(selectedAccount, storageProps.portalClientId, error, { logsAndVars });
    }
  };

  useEffect(() => {
    getAccount();
  }, []);

  const getBrowser = () => {
    /*  if (navigator.userAgent.indexOf("Chrome") != -1) {
      return navigator.userAgent;
    } else if (navigator.userAgent.indexOf("Opera") != -1) {
      return navigator.userAgent;
    } else if (navigator.userAgent.indexOf("MSIE") != -1) {
      return navigator.userAgent;
    } else if (navigator.userAgent.indexOf("Firefox") != -1) {
      return navigator.userAgent;
    } else {
      return "unknown";
    }*/

    var nVer = navigator.appVersion;
    var nAgt = navigator.userAgent;
    var browserName = navigator.appName;
    var fullVersion = "" + parseFloat(navigator.appVersion);
    var majorVersion = parseInt(navigator.appVersion, 10);
    var nameOffset, verOffset, ix;

    // In Opera, the true version is after "OPR" or after "Version"
    if ((verOffset = nAgt.indexOf("OPR")) != -1) {
      browserName = "Opera";
      fullVersion = nAgt.substring(verOffset + 4);
      if ((verOffset = nAgt.indexOf("Version")) != -1) fullVersion = nAgt.substring(verOffset + 8);
    }
    // In MS Edge, the true version is after "Edg" in userAgent
    else if ((verOffset = nAgt.indexOf("Edg")) != -1) {
      browserName = "Microsoft Edge";
      fullVersion = nAgt.substring(verOffset + 4);
    }
    // In MSIE, the true version is after "MSIE" in userAgent
    else if ((verOffset = nAgt.indexOf("MSIE")) != -1) {
      browserName = "Microsoft Internet Explorer";
      fullVersion = nAgt.substring(verOffset + 5);
    }
    // In Chrome, the true version is after "Chrome"
    else if ((verOffset = nAgt.indexOf("Chrome")) != -1) {
      browserName = "Chrome";
      fullVersion = nAgt.substring(verOffset + 7);
    }
    // In Safari, the true version is after "Safari" or after "Version"
    else if ((verOffset = nAgt.indexOf("Safari")) != -1) {
      browserName = "Safari";
      fullVersion = nAgt.substring(verOffset + 7);
      if ((verOffset = nAgt.indexOf("Version")) != -1) fullVersion = nAgt.substring(verOffset + 8);
    }
    // In Firefox, the true version is after "Firefox"
    else if ((verOffset = nAgt.indexOf("Firefox")) != -1) {
      browserName = "Firefox";
      fullVersion = nAgt.substring(verOffset + 8);
    }
    // In most other browsers, "name/version" is at the end of userAgent
    else if ((nameOffset = nAgt.lastIndexOf(" ") + 1) < (verOffset = nAgt.lastIndexOf("/"))) {
      browserName = nAgt.substring(nameOffset, verOffset);
      fullVersion = nAgt.substring(verOffset + 1);
      if (browserName.toLowerCase() == browserName.toUpperCase()) {
        browserName = navigator.appName;
      }
    }
    // trim the fullVersion string at semicolon/space if present
    if ((ix = fullVersion.indexOf(";")) != -1) fullVersion = fullVersion.substring(0, ix);
    if ((ix = fullVersion.indexOf(" ")) != -1) fullVersion = fullVersion.substring(0, ix);

    majorVersion = parseInt("" + fullVersion, 10);
    if (isNaN(majorVersion)) {
      fullVersion = "" + parseFloat(navigator.appVersion);
      majorVersion = parseInt(navigator.appVersion, 10);
    }

    var fullBrowserName = browserName + " " + fullVersion;

    return fullBrowserName;
  };

  const sendEmail = async (e) => {
    e.preventDefault();
    /*
    if (!validator.isEmail(from_email)) {
      console.log("This is not email!");
      // TODO print error and retry
      return;
    }
    */
    let cleanEmail = sanitizeInput(from_email);
    let cleanMessage_1 = sanitizeInput(message_1);
    let cleanMessage_2 = sanitizeInput(message_2);
    let cleanMessage_3 = sanitizeInput(message_3);

    // Server-side delivery (no EmailJS keys in the browser); best-effort.
    await sendFeedbackEmail({
      kind: "survey",
      fromEmail: cleanEmail,
      browser: getBrowser(),
      webpage: window.location.pathname,
      messages: {
        message_1: cleanMessage_1,
        message_2: cleanMessage_2,
        message_3: cleanMessage_3,
      },
      questions: {
        question_1: question_1,
        question_2: question_2 === 2 ? "Yes" : "No",
        question_3: question_3,
        question_4: question_4,
        question_5: question_5 === 1 ? "Yes" : "No",
        question_6: question_6,
        question_7: question_7,
        question_9: question_9,
        question_10: question_10,
      },
    });
    const feedbackChainObj = createStorageJson(
      selectedAccount,
      cleanEmail,
      moment().locale("de").format("DD.MM.YYYY, HH:mm"),
      getBrowser(),
      window.location.pathname,
      cleanMessage_1,
      cleanMessage_2,
      cleanMessage_3,
      question_1,
      question_2,
      question_3,
      question_4,
      question_5,
      question_6,
      question_7,
      //question_8,
      question_9,
      question_10,
      true,
    );
    saveFeedback(feedbackChainObj);
  };

  const saveFeedback = async (jsonObj) => {
    const logsAndVars = createEmptyLogsAndVars("EmailModal:saveFeedback");
    try {
      feedbackJsonStorage.createFeedbackData(jsonObj);
      collectLog(logsAndVars, "feedback is created");
      //context.onSetLoaderTrue();
      setIsSendingInProgress(true);

      /*setTimeout(() => {
        context.onSetLoaderFalse();
      }, 3000);*/
      setTimeout(() => {
        //context.openModal("messagemodal", "Thank you for your feedback!");
        setIsSentTo(true);
      }, 6000);
    } catch (ex) {
      dwReportError(selectedAccount, storageProps.portalClientId, ex, { logsAndVars });
      console.log(ex);
    }
  };

  //pattern={constants.EMAIL_REGEX}

  return (
    <>
      <MDBModal staticBackdrop tabIndex="-1" closeOnEsc={false} show={props.visible} className="email-modal">
        <MDBModalDialog scrollable centered size="md">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>
                <div className="title-text">{t('modals.feedback.title')}</div>
              </MDBModalTitle>
              <MDBBtn className="close" color="none" onClick={props.handleClose} tabIndex="-1">
                <img src={close} alt={t('common.buttons.close')} />
              </MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <form className="profile-form" autoComplete="off" onSubmit={(e) => sendEmail(e)}>
                <div className="form-row">
                  <div className="div-2">
                    <label htmlFor="email" className="navbar-text">
                      {t('modals.feedback.emailOptional')}
                    </label>
                    <input
                      id="email"
                      name="name"
                      placeholder={t('modals.feedback.emailPlaceholder')}
                      className="input-text"
                      type="text"
                      onChange={(event) => setFrom_email(event.target.value)}
                      value={from_email}
                      tabIndex="0"
                    />
                  </div>
                </div>
                <ol>
                  <div className="form-row">
                    <div className="div-2">
                      <span className="navbar-text">
                        <li>{t('modals.feedback.question1')}</li>
                      </span>
                      <div className="radio-div">
                        <span className="text-left">{t('modals.feedback.veryDifficult')}</span>
                        <MDBRadio
                          name="inlineRadio"
                          id="inlineRadio1"
                          value="option1"
                          inline
                          onChange={() => {
                            setQuestion_1(1);
                            setIsSubmitActive(true);
                          }}
                          checked={question_1 === 1}
                        />
                        <MDBRadio
                          name="inlineRadio"
                          id="inlineRadio2"
                          value="option2"
                          inline
                          onChange={() => {
                            setQuestion_1(2);
                            setIsSubmitActive(true);
                          }}
                          checked={question_1 === 2}
                        />
                        <MDBRadio
                          name="inlineRadio"
                          id="inlineRadio3"
                          value="option3"
                          inline
                          onChange={() => {
                            setQuestion_1(3);
                            setIsSubmitActive(true);
                          }}
                          checked={question_1 === 3}
                        />
                        <MDBRadio
                          name="inlineRadio"
                          id="inlineRadio4"
                          value="option4"
                          inline
                          onChange={() => {
                            setQuestion_1(4);
                            setIsSubmitActive(true);
                          }}
                          checked={question_1 === 4}
                        />
                        <MDBRadio
                          name="inlineRadio"
                          id="inlineRadio5"
                          value="option5"
                          inline
                          onChange={() => {
                            setQuestion_1(5);
                            setIsSubmitActive(true);
                          }}
                          checked={question_1 === 5}
                        />
                        <MDBRadio
                          name="inlineRadio"
                          id="inlineRadio6"
                          value="option6"
                          inline
                          onChange={() => {
                            setQuestion_1(6);
                            setIsSubmitActive(true);
                          }}
                          checked={question_1 === 6}
                        />
                        <span className="text-right">{t('modals.feedback.veryEasy')}</span>
                      </div>
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="div-2">
                      <span className="navbar-text">
                        <li>{t('modals.feedback.question2')}</li>
                      </span>
                      <div className="radio-div">
                        <span className="text-left-2">{t('common.buttons.no')}</span>
                        <MDBRadio
                          name="inlineRadio2"
                          id="inlineRadio7"
                          value="option7"
                          inline
                          onChange={() => {
                            setQuestion_2(1);
                            setIsSubmitActive(true);
                          }}
                          checked={question_2 === 1}
                        />
                        <span className="text-right-2">{t('common.buttons.yes')}</span>
                        <MDBRadio
                          name="inlineRadio2"
                          id="inlineRadio8"
                          value="option8"
                          inline
                          onChange={() => {
                            setQuestion_2(2);
                            setIsSubmitActive(true);
                          }}
                          checked={question_2 === 2}
                        />
                      </div>
                    </div>
                  </div>
                  {question_2 === 2 && (
                    <div className="form-row">
                      <div className="div-2">
                        <label htmlFor="message" className="navbar-text">
                          {t('modals.feedback.ifYesWhichOne') + " (" + message_1.length + "/140) *"}
                        </label>
                        <textarea
                          id="message_1"
                          name="message_1"
                          rows="4"
                          placeholder={t('modals.feedback.messagePlaceholder')}
                          className="textarea-text"
                          type="text"
                          onChange={(event) => {
                            if (event.target.value.length >= 140) {
                              setIsWarningTicket(true);
                              //context.openModal("messagemodal", "You have reached the maximum number of characters!");
                            } else {
                              setMessage_1(event.target.value);
                            }
                          }}
                          value={message_1}
                          tabIndex="0"
                          maxLength={constants.FEEDBACK_DESCRIPTION_CHARACTER_LIMIT}
                        />
                      </div>
                    </div>
                  )}

                  <div className="form-row">
                    <div className="div-2">
                      <span className="navbar-text">
                        <li>{t('modals.feedback.question3')}</li>
                      </span>
                      <div className="radio-div">
                        <span className="text-left">{t('modals.feedback.veryIncomprehensible')}</span>
                        <MDBRadio
                          name="inlineRadio3"
                          id="inlineRadio9"
                          value="option9"
                          inline
                          onChange={() => {
                            setQuestion_3(1);
                            setIsSubmitActive(true);
                          }}
                          checked={question_3 === 1}
                        />
                        <MDBRadio
                          name="inlineRadio3"
                          id="inlineRadio10"
                          value="option10"
                          inline
                          onChange={() => {
                            setQuestion_3(2);
                            setIsSubmitActive(true);
                          }}
                          checked={question_3 === 2}
                        />
                        <MDBRadio
                          name="inlineRadio3"
                          id="inlineRadio11"
                          value="option11"
                          inline
                          onChange={() => {
                            setQuestion_3(3);
                            setIsSubmitActive(true);
                          }}
                          checked={question_3 === 3}
                        />
                        <MDBRadio
                          name="inlineRadio3"
                          id="inlineRadio12"
                          value="option12"
                          inline
                          onChange={() => {
                            setQuestion_3(4);
                            setIsSubmitActive(true);
                          }}
                          checked={question_3 === 4}
                        />
                        <MDBRadio
                          name="inlineRadio3"
                          id="inlineRadio13"
                          value="option13"
                          inline
                          onChange={() => {
                            setQuestion_3(5);
                            setIsSubmitActive(true);
                          }}
                          checked={question_3 === 5}
                        />
                        <MDBRadio
                          name="inlineRadio3"
                          id="inlineRadio14"
                          value="option14"
                          inline
                          onChange={() => {
                            setQuestion_3(6);
                            setIsSubmitActive(true);
                          }}
                          checked={question_3 === 6}
                        />
                        <span className="text-right">{t('modals.feedback.veryComprehensible')}</span>
                      </div>
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="div-2">
                      <span className="navbar-text">
                        <li>{t('modals.feedback.question4')}</li>
                      </span>
                      <div className="radio-div">
                        <span className="text-left">{t('modals.feedback.notAtAll')}</span>
                        <MDBRadio
                          name="inlineRadio4"
                          id="inlineRadio15"
                          value="option15"
                          inline
                          onChange={() => {
                            setQuestion_4(1);
                            setIsSubmitActive(true);
                          }}
                          checked={question_4 === 1}
                        />
                        <MDBRadio
                          name="inlineRadio4"
                          id="inlineRadio16"
                          value="option16"
                          inline
                          onChange={() => {
                            setQuestion_4(2);
                            setIsSubmitActive(true);
                          }}
                          checked={question_4 === 2}
                        />
                        <MDBRadio
                          name="inlineRadio4"
                          id="inlineRadio17"
                          value="option17"
                          inline
                          onChange={() => {
                            setQuestion_4(3);
                            setIsSubmitActive(true);
                          }}
                          checked={question_4 === 3}
                        />
                        <MDBRadio
                          name="inlineRadio4"
                          id="inlineRadio18"
                          value="option18"
                          inline
                          onChange={() => {
                            setQuestion_4(4);
                            setIsSubmitActive(true);
                          }}
                          checked={question_4 === 4}
                        />
                        <MDBRadio
                          name="inlineRadio4"
                          id="inlineRadio19"
                          value="option19"
                          inline
                          onChange={() => {
                            setQuestion_4(5);
                            setIsSubmitActive(true);
                          }}
                          checked={question_4 === 5}
                        />
                        <MDBRadio
                          name="inlineRadio4"
                          id="inlineRadio20"
                          value="option20"
                          inline
                          onChange={() => {
                            setQuestion_4(6);
                            setIsSubmitActive(true);
                          }}
                          checked={question_4 === 6}
                        />
                        <span className="text-right">{t('modals.feedback.veryGood')}</span>
                      </div>
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="div-2">
                      <span className="navbar-text">
                        <li>{t('modals.feedback.question5')}</li>
                      </span>
                      <div className="radio-div">
                        <span className="text-left-2">{t('common.buttons.no')}</span>
                        <MDBRadio
                          name="inlineRadio5"
                          id="inlineRadio21"
                          value="option21"
                          inline
                          onChange={() => {
                            setQuestion_5(1);
                            setIsSubmitActive(true);
                          }}
                          checked={question_5 === 1}
                        />
                        <span className="text-right-2">{t('common.buttons.yes')}</span>
                        <MDBRadio
                          name="inlineRadio5"
                          id="inlineRadio22"
                          value="option22"
                          inline
                          onChange={() => {
                            setQuestion_5(2);
                            setIsSubmitActive(true);
                          }}
                          checked={question_5 === 2}
                        />
                      </div>
                    </div>
                  </div>
                  {question_5 === 1 && (
                    <div className="form-row">
                      <div className="div-2">
                        <label htmlFor="message" className="navbar-text">
                          {t('modals.feedback.ifNoWhatIrritated') + " (" + message_2.length + "/140) *"}
                        </label>
                        <textarea
                          id="message_2"
                          name="message_2"
                          rows="4"
                          placeholder={t('modals.feedback.messagePlaceholder')}
                          className="textarea-text"
                          type="text"
                          onChange={(event) => {
                            if (event.target.value.length >= 140) {
                              setIsWarningTicket(true);
                              //context.openModal("messagemodal", "You have reached the maximum number of characters!");
                            } else {
                              setMessage_2(event.target.value);
                            }
                          }}
                          value={message_2}
                          tabIndex="0"
                          maxLength={constants.FEEDBACK_DESCRIPTION_CHARACTER_LIMIT}
                        />
                      </div>
                    </div>
                  )}

                  <div className="form-row">
                    <div className="div-2">
                      <span className="navbar-text">
                        <li>{t('modals.feedback.question6')}</li>
                      </span>
                      <div className="radio-div">
                        <span className="text-left">{t('modals.feedback.veryPoor')}</span>
                        <MDBRadio
                          name="inlineRadio6"
                          id="inlineRadio23"
                          value="option23"
                          inline
                          onChange={() => {
                            setQuestion_6(1);
                            setIsSubmitActive(true);
                          }}
                          checked={question_6 === 1}
                        />
                        <MDBRadio
                          name="inlineRadio6"
                          id="inlineRadio24"
                          value="option24"
                          inline
                          onChange={() => {
                            setQuestion_6(2);
                            setIsSubmitActive(true);
                          }}
                          checked={question_6 === 2}
                        />
                        <MDBRadio
                          name="inlineRadio6"
                          id="inlineRadio25"
                          value="option25"
                          inline
                          onChange={() => {
                            setQuestion_6(3);
                            setIsSubmitActive(true);
                          }}
                          checked={question_6 === 3}
                        />
                        <MDBRadio
                          name="inlineRadio6"
                          id="inlineRadio26"
                          value="option26"
                          inline
                          onChange={() => {
                            setQuestion_6(4);
                            setIsSubmitActive(true);
                          }}
                          checked={question_6 === 4}
                        />
                        <MDBRadio
                          name="inlineRadio6"
                          id="inlineRadio27"
                          value="option27"
                          inline
                          onChange={() => {
                            setQuestion_6(5);
                            setIsSubmitActive(true);
                          }}
                          checked={question_6 === 5}
                        />
                        <MDBRadio
                          name="inlineRadio6"
                          id="inlineRadio28"
                          value="option28"
                          inline
                          onChange={() => {
                            setQuestion_6(6);
                            setIsSubmitActive(true);
                          }}
                          checked={question_6 === 6}
                        />
                        <span className="text-right">{t('modals.feedback.veryGood')}</span>
                      </div>
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="div-2">
                      <span className="navbar-text">
                        <li>{t('modals.feedback.question7')}</li>
                      </span>
                      <div className="radio-div">
                        <span className="text-left">{t('modals.feedback.notAtAll')}</span>
                        <MDBRadio
                          name="inlineRadio7"
                          id="inlineRadio29"
                          value="option29"
                          inline
                          onChange={() => {
                            setQuestion_7(1);
                            setIsSubmitActive(true);
                          }}
                          checked={question_7 === 1}
                        />
                        <MDBRadio
                          name="inlineRadio7"
                          id="inlineRadio30"
                          value="option30"
                          inline
                          onChange={() => {
                            setQuestion_7(2);
                            setIsSubmitActive(true);
                          }}
                          checked={question_7 === 2}
                        />
                        <MDBRadio
                          name="inlineRadio7"
                          id="inlineRadio31"
                          value="option31"
                          inline
                          onChange={() => {
                            setQuestion_7(3);
                            setIsSubmitActive(true);
                          }}
                          checked={question_7 === 3}
                        />
                        <MDBRadio
                          name="inlineRadio7"
                          id="inlineRadio32"
                          value="option32"
                          inline
                          onChange={() => {
                            setQuestion_7(4);
                            setIsSubmitActive(true);
                          }}
                          checked={question_7 === 4}
                        />
                        <MDBRadio
                          name="inlineRadio7"
                          id="inlineRadio33"
                          value="option33"
                          inline
                          onChange={() => {
                            setQuestion_7(5);
                            setIsSubmitActive(true);
                          }}
                          checked={question_7 === 5}
                        />
                        <MDBRadio
                          name="inlineRadio7"
                          id="inlineRadio34"
                          value="option34"
                          inline
                          onChange={() => {
                            setQuestion_7(6);
                            setIsSubmitActive(true);
                          }}
                          checked={question_7 === 6}
                        />
                        <span className="text-right">{t('modals.feedback.veryGood')}</span>
                      </div>
                    </div>
                  </div>
                  {/*
                  <div className="form-row">
                    <div className="div-2">
                      <span className="navbar-text">
                        <li>How would you rate the usability of the platform for uploading and managing data?</li>
                      </span>
                      <div className="radio-div">
                        <span className="text-left">very poor</span>
                        <MDBRadio
                          name="inlineRadio8"
                          id="inlineRadio35"
                          value="option35"
                          inline
                          onChange={() => setQuestion_8(1)}
                          checked={question_8 === 1}
                        />
                        <MDBRadio
                          name="inlineRadio8"
                          id="inlineRadio36"
                          value="option36"
                          inline
                          onChange={() => setQuestion_8(2)}
                          checked={question_8 === 2}
                        />
                        <MDBRadio
                          name="inlineRadio8"
                          id="inlineRadio37"
                          value="option37"
                          inline
                          onChange={() => setQuestion_8(3)}
                          checked={question_8 === 3}
                        />
                        <MDBRadio
                          name="inlineRadio8"
                          id="inlineRadio38"
                          value="option38"
                          inline
                          onChange={() => setQuestion_8(4)}
                          checked={question_8 === 4}
                        />
                        <MDBRadio
                          name="inlineRadio8"
                          id="inlineRadio39"
                          value="option39"
                          inline
                          onChange={() => setQuestion_8(5)}
                          checked={question_8 === 5}
                        />
                        <MDBRadio
                          name="inlineRadio8"
                          id="inlineRadio40"
                          value="option40"
                          inline
                          onChange={() => setQuestion_8(6)}
                          checked={question_8 === 6}
                        />
                        <span className="text-right">very good</span>
                      </div>
                    </div>
                  </div>
                  */}
                  <div className="form-row">
                    <div className="div-2">
                      <span className="navbar-text">
                        <li>{t('modals.feedback.question8')}</li>
                      </span>
                    </div>
                    <div className="div-2">
                      <label htmlFor="message" className="navbar-text">
                        {t('modals.feedback.writeUsYourIdeas') + " (" + message_3.length + "/140) *"}
                      </label>
                      <textarea
                        id="message_3"
                        name="message_3"
                        rows="4"
                        placeholder={t('modals.feedback.messagePlaceholder')}
                        className="textarea-text"
                        type="text"
                        onChange={(event) => {
                          if (event.target.value.length >= 140) {
                            setIsWarningTicket(true);
                            //context.openModal("messagemodal", "You have reached the maximum number of characters!");
                          } else {
                            setMessage_3(event.target.value);
                          }
                        }}
                        value={message_3}
                        tabIndex="0"
                        maxLength={constants.FEEDBACK_DESCRIPTION_CHARACTER_LIMIT}
                      />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="div-2">
                      <span className="navbar-text">
                        <li>{t('modals.feedback.question9')}</li>
                      </span>
                      <div className="radio-div">
                        <span className="text-left">{t('modals.feedback.veryUnlikely')}</span>
                        <MDBRadio
                          name="inlineRadio9"
                          id="inlineRadio41"
                          value="option41"
                          inline
                          onChange={() => {
                            setQuestion_9(1);
                            setIsSubmitActive(true);
                          }}
                          checked={question_9 === 1}
                        />
                        <MDBRadio
                          name="inlineRadio9"
                          id="inlineRadio42"
                          value="option42"
                          inline
                          onChange={() => {
                            setQuestion_9(2);
                            setIsSubmitActive(true);
                          }}
                          checked={question_9 === 2}
                        />
                        <MDBRadio
                          name="inlineRadio9"
                          id="inlineRadio43"
                          value="option43"
                          inline
                          onChange={() => {
                            setQuestion_9(3);
                            setIsSubmitActive(true);
                          }}
                          checked={question_9 === 3}
                        />
                        <MDBRadio
                          name="inlineRadio9"
                          id="inlineRadio44"
                          value="option44"
                          inline
                          onChange={() => {
                            setQuestion_9(4);
                            setIsSubmitActive(true);
                          }}
                          checked={question_9 === 4}
                        />
                        <MDBRadio
                          name="inlineRadio9"
                          id="inlineRadio45"
                          value="option45"
                          inline
                          onChange={() => {
                            setQuestion_9(5);
                            setIsSubmitActive(true);
                          }}
                          checked={question_9 === 5}
                        />
                        <MDBRadio
                          name="inlineRadio9"
                          id="inlineRadio46"
                          value="option46"
                          inline
                          onChange={() => {
                            setQuestion_9(6);
                            setIsSubmitActive(true);
                          }}
                          checked={question_9 === 6}
                        />
                        <span className="text-right">{t('modals.feedback.veryLikely')}</span>
                      </div>
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="div-2">
                      <span className="navbar-text">
                        <li>
                          {t('modals.feedback.question10')}
                        </li>
                      </span>
                      <div className="radio-div">
                        <span className="text-left">{t('modals.feedback.tooExpensive')}</span>
                        <MDBRadio
                          name="inlineRadio10"
                          id="inlineRadio47"
                          value="option47"
                          inline
                          onChange={() => {
                            setQuestion_10(1);
                            setIsSubmitActive(true);
                          }}
                          checked={question_10 === 1}
                        />
                        <MDBRadio
                          name="inlineRadio10"
                          id="inlineRadio48"
                          value="option48"
                          inline
                          onChange={() => {
                            setQuestion_10(2);
                            setIsSubmitActive(true);
                          }}
                          checked={question_10 === 2}
                        />
                        <MDBRadio
                          name="inlineRadio10"
                          id="inlineRadio49"
                          value="option49"
                          inline
                          onChange={() => {
                            setQuestion_10(3);
                            setIsSubmitActive(true);
                          }}
                          checked={question_10 === 3}
                        />
                        <MDBRadio
                          name="inlineRadio10"
                          id="inlineRadio50"
                          value="option50"
                          inline
                          onChange={() => {
                            setQuestion_10(4);
                            setIsSubmitActive(true);
                          }}
                          checked={question_10 === 4}
                        />
                        <MDBRadio
                          name="inlineRadio10"
                          id="inlineRadio51"
                          value="option51"
                          inline
                          onChange={() => {
                            setQuestion_10(5);
                            setIsSubmitActive(true);
                          }}
                          checked={question_10 === 5}
                        />
                        <MDBRadio
                          name="inlineRadio10"
                          id="inlineRadio52"
                          value="option52"
                          inline
                          onChange={() => {
                            setQuestion_10(6);
                            setIsSubmitActive(true);
                          }}
                          checked={question_10 === 6}
                        />
                        <span className="text-right">{t('modals.feedback.tooFavorable')}</span>
                      </div>
                    </div>
                  </div>
                </ol>
                <div className="form-row">
                  <div className="div-3">
                    <button
                      type="button"
                      className="button subtle medium"
                      onClick={() => props.handleClose()}
                      tabIndex="-1"
                    >
                      <div className="text p15">{t('common.buttons.cancel')}</div>
                    </button>
                    <button type="submit" className="button brand medium" tabIndex="0" disabled={!isSubmitActive}>
                      <div className="text p15">{t('common.buttons.submit')}</div>
                    </button>
                  </div>
                </div>
              </form>
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
      <div className="ticket-div">
        {isSendingInProgress && (
          <>
            <InformationsTicket close={() => setIsSendingInProgress(false)} text={t('modals.feedback.sendingInProgress')} />
            <div style={{ height: "20px" }} />
          </>
        )}
        {isSentTo && (
          <>
            <NotificationsTicket
              close={() => {
                setIsSentTo(false);
                context.onSetIsRender();
                props.handleClose();
              }}
              text={t('modals.feedback.thankYou')}
            />
            <div style={{ height: "20px" }} />
          </>
        )}
        {isWarningTicket && (
          <>
            <WarningTicket
              close={() => {
                setIsWarningTicket(false);
              }}
              text={t('modals.feedback.maxCharacters')}
            />
            <div style={{ height: "20px" }} />
          </>
        )}
      </div>
    </>
  );
}
